import React from "react";

const CPP_Home = () => {
  return (
    <div>
      <h1>CPP_Home Component</h1>
      <p>Content for CPP_Home goes here...</p>
    </div>
  );
};

export default CPP_Home;
